// Foto de produto em miniatura (dono, 25/09/2026: a tela de lançar demorava a
// carregar no celular). A foto salva tem 1080 px; o servidor gera e guarda a
// versão de 128/256/400 px (`GET /api/uploads/products/mini/{largura}/{arquivo}`,
// cache de 1 ano). Foto que não é de produto (avatar, link externo) sai como veio.
// Também as fotos do banco de fotos padrão (/uploads/padrao/, 23/10/2026).
const PRODUTO = /^\/?(?:api\/)?uploads\/(products|padrao)\/([^/?#]+)$/;

// Miniatura quando é foto de produto; null quando não é (cada tela decide o resto)
export function miniaturaDoProduto(url, largura = 400) {
  if (!url) return null;
  const m = String(url).match(PRODUTO);
  return m ? `/api/uploads/${m[1]}/mini/${largura}/${m[2]}` : null;
}

export function miniaturaDe(url, largura = 400) {
  if (!url) return null;
  if (/^https?:\/\//.test(url)) return url;
  return miniaturaDoProduto(url, largura) || `/api${url.startsWith("/") ? url : "/" + url}`;
}
